<template>
  <simplebar class="chits-wrapper">
    <div class="chits">
      <div v-for="(chit, index) in chits" :key="index" class="chit">
        <span>{{ `${chit.col_name} = ${chit.name}` }}</span>
        <icon size="18" @click="$emit('clearFilter', chit)">clear</icon>
      </div>
    </div>
  </simplebar>
</template>

<script>
export default {
  props: {
    chits: Array,
  },
};
</script>

<style lang="scss" scoped>
.chits-wrapper {
  width: 100%;
  flex: 1;
  margin: 0 10px 0 0;
}
.chits {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;

  .chit {
    display: flex;
    align-items: center;
    background: var(--color-primary-light);
    border-radius: 5px;
    padding: 2px 5px 2px 10px;
    margin-left: 10px;

    &:first-of-type {
      margin-left: 0;
    }

    span {
      white-space: nowrap;
    }
    i {
      color: var(--color-primary);
      padding: 5px;
      background: var(--color-secondary-light);

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
